import React from 'react';
import { N20 } from '@atlaskit/adf-schema';
import { Box, xcss } from '@atlaskit/primitives';
import Select from '@atlaskit/select';
import { DisplayMode } from '../../../RenderForm';
import { ViewWrapper } from '../../common/questionWrappers';
const styles = {
  control: base => ({
    ...base,
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${N20})`,
    borderColor: "var(--ds-border-disabled, #DFE1E6)",
    color: "var(--ds-text, #172B4D !important)"
  }),
  menu: base => ({
    ...base,
    color: "var(--ds-text, #172B4D)"
  })
};
const containerStyles = xcss({
  display: 'flex',
  flexDirection: 'row'
});
const parentStyles = xcss({
  width: '50%',
  marginRight: 'space.100'
});
const childStyles = xcss({
  width: '50%'
});
export const ViewCascadingDropdown = ({
  id,
  value,
  childValue,
  displayMode
}) => {
  if (displayMode === DisplayMode.Edit || displayMode === DisplayMode.Preview || displayMode === DisplayMode.Translate) {
    // The Select displays as disabled in these modes
    return /*#__PURE__*/React.createElement(Box, {
      xcss: containerStyles
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: parentStyles
    }, /*#__PURE__*/React.createElement(Select, {
      id: id,
      value: value,
      placeholder: "",
      isDisabled: true,
      styles: styles
    })), /*#__PURE__*/React.createElement(Box, {
      xcss: childStyles
    }, /*#__PURE__*/React.createElement(Select, {
      id: id,
      value: childValue,
      placeholder: "",
      isDisabled: true,
      styles: styles
    })));
  }
  return /*#__PURE__*/React.createElement(ViewWrapper, null, value ? `${value.label}` + (childValue ? ` - ${childValue.label}` : '') : '');
};